import { EarthBoxMinusIcon } from './EarthBoxMinusIcon';

/**
 * author: Muhammet Balsoy
 * id C6EEACD5-6E55-4A4A-8E66-0CC8233470DA
 * name earth-box-minus
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-box-minus.svg
 * tags
 * - Navigation 
 */
export const PlanetBoxMinusIcon = EarthBoxMinusIcon;
export default PlanetBoxMinusIcon